// extracted by mini-css-extract-plugin
module.exports = {"maxMenu":"Header_maxMenu__1GZga","logoLink":"Header_logoLink__KQXWI","miniMenu":"Header_miniMenu__1YLN9","menu":"Header_menu__3xjde","hamburguer":"Header_hamburguer__3IijU"};